import { useCallback } from 'react';
import { createHookSegment } from '../clipUpdateDataUtilsWithSplits/createHookSegment';
import { remotionPlayerStateStore } from '../store/remotionPlayerState';
import { getPlayerTimeFromSegmentTime } from '../timeUtils';
import { useRemotionPlayerSeek } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useRemotionPlayerSeek';
import { Clip } from '@/domains/asset';
import EventBus from '@/libs/eventBus/eventBus';
import { CustomEvents } from '@/libs/eventBus/constants';

type CreateHookArgs = {
  startTime: number;
  endTime: number;
  startSegmentId: string;
  endSegmentId: string;
  clipData: Clip;
  clipId: string;
};

export default function useCreateHookSegment() {
  const { seekTo, subscribeToSeekEvents } = useRemotionPlayerSeek();

  return useCallback(
    ({ startTime, endTime, startSegmentId, endSegmentId, clipData, clipId }: CreateHookArgs) => {
      const success = createHookSegment({ startTime, endTime, startSegmentId, endSegmentId, clipData, clipId });
      if (success) {
        const hookDuration =
          getPlayerTimeFromSegmentTime(endTime, clipData, endSegmentId) -
          getPlayerTimeFromSegmentTime(startTime, clipData, startSegmentId);
        const newSeekTime = remotionPlayerStateStore.getSnapshot().currentTime;

        seekTo(newSeekTime + hookDuration);

        const unsubscribe = subscribeToSeekEvents(() => {
          unsubscribe();
          EventBus.dispatch(CustomEvents.TimelineForcedScroll, {
            time: startTime,
            segmentId: startSegmentId
          });
        });
      }
      return success;
    },
    [seekTo, subscribeToSeekEvents]
  );
}
